<!-- src/components/Home.vue -->

<template>
  <div>
    <header-component />
    <refundPolicyBanner-component />
    <footer-component />
  </div>
</template>

<script>
import headerComponent from '../header/headerComponent.vue';
import refundPolicyBannerComponent from '../refundPolicy/refundPolicyBannerComponent.vue';
import footerComponent from '../footer/footerComponent.vue';

export default {
  name: 'homeComponent',
  components: {
    headerComponent,
    refundPolicyBannerComponent,
    footerComponent,
  },
};
</script>
